import { render, staticRenderFns } from "./FileView.html?vue&type=template&id=3093a74e&scoped=true&"
import script from "./FileView.vue?vue&type=script&lang=js&"
export * from "./FileView.vue?vue&type=script&lang=js&"
import style0 from "./FileView.scss?vue&type=style&index=0&id=3093a74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3093a74e",
  null
  
)

export default component.exports